<template>
  <div>
    <view-title>
      <v-icon class="primary--text mr-4">fas fa-users</v-icon>
      {{ $route.params.id ? 'Editar' : 'Adicionar' }} usuário
    </view-title>
    <v-container>
      <v-row>
        <v-col>
          <v-card :loading="loading">
            <v-card-text>
              <v-form ref="editForm">
                <form-title title="Credenciais de acesso" />
                <v-row>
                  <v-col
                    cols="12"
                    sm="6"
                  >
                    <v-text-field
                      :value="editItem.name"
                      :rules="[rules.required]"
                      label="Nome"
                      @input="onEditChange({name: $event})"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                  >
                    <v-text-field
                      :value="editItem.email"
                      :rules="[rules.emailRules, rules.required]"
                      label="E-mail"
                      type="email"
                      @input="onEditChange({email: $event})"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    sm="6"
                  >
                    <v-text-field
                      :value="editItem.password"
                      :rules="$route.params.id ? [] : [rules.min8, rules.required]"
                      label="Senha"
                      :append-icon="showPass ? 'fas fa-eye' : 'fas fa-eye-slash'"
                      :type="showPass ? 'text' : 'password'"
                      @click:append="showPass = !showPass"
                      @input="onEditChange({password: $event})"
                    />
                  </v-col>
                </v-row>
                <form-title title="Dados cadastrais" />
                <v-row>
                  <v-col
                    cols="12"
                    sm="6"
                  >
                    <v-text-field
                      v-mask="['+55 (##) ####-####', '+55 (##) #####-####']"
                      label="Telefone *"
                      :rules="[rules.required]"
                      :value="editItem.phone"
                      @input="onEditChange({phone: $event})"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                  >
                    <v-select
                      :items="roles"
                      item-text="name"
                      label="Perfil de usuário *"
                      :rules="[rules.required]"
                      :value="editItem.editRole"
                      @input="onEditChange({editRole: $event})"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    sm="6"
                  >
                    <v-text-field
                      label="Empresa"
                      :value="editItem.company"
                      @input="onEditChange({company: $event})"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                  >
                    <v-select
                      :items="education"
                      label="Escolaridade"
                      :value="editItem.education"
                      @input="onEditChange({education: $event})"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <div class="flex-grow-1"></div>
              <v-btn
                color="accent"
                text
                :to="{name : 'Usuários listar'}"
              >Cancelar</v-btn>
              <v-btn
                color="primary"
                rounded
                @click="onEditSave($refs.editForm)"
              >
                {{ $route.params.id ? 'Salvar' : 'Adicionar' }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import formRules from '@/mixins/form-rules';
import viewTitle from '@/components/view-title.vue';
import formTitle from '@/components/form-title.vue';

export default {
  mixins: [formRules],
  components: {
    viewTitle,
    formTitle,
  },
  data() {
    return {
      showPass: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.afterRouteUpdate(to);
    });
  },
  beforeRouteUpdate(to, from, next) {
    this.afterRouteUpdate(to);
    next();
  },
  beforeRouteLeave(to, from, next) {
    this.$refs.editForm.reset();
    next();
  },
  computed: mapGetters('views/users/upsert', [
    'loading',
    'editItem',
    'roles',
    'education',
  ]),
  methods: mapActions('views/users/upsert', [
    'afterRouteUpdate',
    'loadAccount',
    'onEditChange',
    'onEditSave',
  ]),
};
</script>
